import { Pipe, PipeTransform } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Pipe({
  name: 'asyncFunction',
})
export class AsyncFuncPipe implements PipeTransform {
  transform(
    asyncFunc: (
      ..._args
    ) => Observable<any> | BehaviorSubject<any> | Promise<any>,
    ...args: any
  ): any {
    return asyncFunc(...args);
  }
}
